import * as angular from "angular";
import {IController} from "angular";
import {ContentTemplateModel} from "../../models/content-template.model";

export class ContentTemplatesTableRowComponent implements IController {

  template: ContentTemplateModel;
  onEdit: Function;
  onDelete: Function;
  constructor() {
  }

}

angular
  .module('bringoz.admin.content-templates')
  .component('contentTemplatesTableRow', {
    bindings: {
      template: '<',
      onEdit: '&',
      onDelete: '&'
    },
    template: require('./content-templates-table-row.html').default,
    controller: ContentTemplatesTableRowComponent
  });
